<template>
  <div id="wanfoshenxiangyou">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>万佛神香油</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">万佛神香油</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="
                    require('@/assets/img/products/wan-fo-shen-xiang-you.jpg')
                  "
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『万佛神香油』</h5>

                <p class="project-description">
                  <span><b>用法：</b></span>
                </p>

                <p class="project-description">
                  (一)
                  入伙：入伙时，涂抹在新家的前门、後门，或新张营业的招牌上，有趋吉避凶，招纳贵人财运，生意兴隆的功效。
                </p>

                <p class="project-description">
                  (二)
                  汽车：不论是汽车、电单车或三轮车，只要涂抹在车牌上：本身若有财气，更会催财运，车牌会得以早日开出，中奖得财：最重要的，也具有庇佑作用：出入平安、一路顺风及辟邪驱魔。
                </p>

                <p class="project-description">
                  (三) 神台：涂抹神台上，香气袅袅，神佛皆喜。
                </p>

                <p class="project-description">
                  (四)
                  天灯：家有天灯者，可在每月初一、十五，添加‘万佛神香油’肯定灵力大增，保佑合家平安。
                </p>

                <p class="project-description">
                  (五)
                  油灯：家有供奉主神的油灯和地主油灯，在每逢初一及十五，添加
                  ‘万佛神香油’合家平安，工作一帆风顺，事业蒸蒸日上。
                </p>

                <p class="project-description">
                  (六) 应征：在应征工作时，用 ‘万佛神香油’
                  涂抹一点在额头上，顿时开运，信心洋溢，对应征者具有增加信心与气定神闲的作用。
                </p>

                <p class="project-description">
                  (七) 人缘：袋子里放一支 ‘万佛神香油’
                  ，可以增进人缘，在公司里与同事融洽相处，做经销的推销员不但人事融洽，广结善缘，四处逢贵人，也有助业务提升。
                </p>

                <p class="project-description">
                  (八)
                  转运：如果发现自己的运势走下坡时，譬如头头碰著黑、做事不顺、买万字跳字，这时候只须添加‘万佛神香油’在神台上的油灯。如果家中没有供奉神明者，可置放在办公桌或家里的写字桌上，再不然就是放在本命宫的财位上，运势自然会转旺。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="wan-fo-shen-xiang-you" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "WanFoShenXiangYou",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/WanFoShenXiangYou.vue